import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ETextDecoration } from '@sharedComponents/Buttons';
import { AlignedInfoMark } from '@styles/cartComponents';
import { ReactFCC } from '@types';

import { messages } from '../messages';
import { StyledTitle, StyledTitleLink } from '../styled';

export const BenefitItemTitle: ReactFCC<{ active: boolean; onClick: () => void; activationThreshold: number }> = ({
  active,
  onClick,
  activationThreshold,
  children,
}) =>
  active ? (
    <StyledTitle data-testid="active-benefit-item-title">{children}</StyledTitle>
  ) : (
    <div>
      <StyledTitleLink
        data-testid="inactive-benefit-item-link"
        onClickAction={onClick}
        disabled={false}
        textDecoration={ETextDecoration.UNDERLINE}
        hasHover={true}>
        {children}
      </StyledTitleLink>
      <AlignedInfoMark
        data-testid="inactive-benefit-item-info-mark"
        content={
          <FormattedMessage
            {...messages.benefitFreeShippingTermsAndConditions}
            values={{ price: activationThreshold }}
          />
        }
      />
    </div>
  );
